import ngCookies from 'angular-cookies';
import angularJwt from 'angular-jwt';

import { AuthTokenServiceModule } from './authToken.service';

export const ConciergeAuthServiceModule = angular
    .module('app.services.auth.conciergeAuthService', [
        ngCookies,
        angularJwt,
        AuthTokenServiceModule
    ])
    .service('conciergeAuthService', (
        $cookies,
        $q,
        $state,
        jwtHelper,
        authTokenService
    ) => {
        function isImpersonator() {
            return authTokenService.getDecodedIdToken().then((decoded) => {
                if (decoded) {
                    return !!decoded.impersonated || !!decoded['https://api.material.com/concierge'];
                }
                return false;
            });
        }

        function getDecodedJWT(token) {
            if (token) {
                const decoded = jwtHelper.decodeToken(token);
                if (decoded) {
                    return decoded;
                }
            }
            return null;
        }

        return {
            isImpersonator,
            getDecodedJWT
        };
    })
    .name;



// WEBPACK FOOTER //
// ./src/app/services/auth/conciergeAuth.service.js